export default "__VITE_ASSET__CS70Jrr2__"